<div class="bottomSheetWidget">
  <mat-nav-list>
    <a href="" id="fbLnkBtn" (click)="openLink($event)">
      <span matListItemTitle>
        <img src="../../../../../assets/facebookLogo-black.svg" alt="facebook logo">
        Facebook
        <div id="fbShareBtn" class="fb-share-button" data-href="https://uvuyo-prod.firebaseapp.com/"
          data-layout="button">
        </div>
      </span>
      <span matLine class="bottomSheetBtnInfo">Share with your facebook friends.</span>
    </a>

    <a href="" id="linkedInLnkBtn" (click)="openLink($event)">
      <span matListItemTitle>
        <img src="../../../../../assets/linkedInLogo-black.svg" alt="linkedIn logo">
        LinkedIn
        <div id="linkedInShareBtnWrapper">
        </div>
      </span>
      <span matLine class="bottomSheetBtnInfo">Share to LinkedIn</span>
    </a>

    <a href="" id="twitterLnkBtn" (click)="openLink($event)">
      <span matListItemTitle>
        <img src="../../../../../assets/twitterLogo-black.svg" alt="twitter logo">
        <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" id="twitter-share-button" class="twitter-share-button"
          data-show-count="false">
          Twitter
        </a>
        <img id="twitterShareImg" src="../../../../../assets/twitterShare.png" alt="Twitter Share Button Image"/>
      </span>
      <span matLine class="bottomSheetBtnInfo">Share to Twitter</span>
    </a>
  </mat-nav-list>
</div>